import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {};
export const b = b_.with('PhoneInput');